export const imageDelete = require("./imageDelete.png");
export const uploadImage = require("../../src/commonAssets/uploadImage.png")
export const showChartIcon = require("../../src/commonAssets/showchart.png")
export const calendarIcon = require("../../src/commonAssets/calendar_icon.png")
export const totalIcon = require("../../src/commonAssets/total_icon.png")
export const iconPdf = require("../../src/commonAssets/iconpdf.svg");
export const iconJpeg = require("../../src/commonAssets/iconjpeg.svg");
export const iconCheck = require("../../src/commonAssets/round-check.svg");
export const searchIcon = require("../../src/commonAssets/search_icon.png");
export const clockIcon = require("../../src/commonAssets/clock_icon.png");